import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useEndPoint } from "../../../Hooks/useEndPoint";
import SearchInput from "../../SearchInput/SearchInput"
import { useSelector } from "react-redux";


const Index = forwardRef(({label,placeholder,masterType,filterData},ref) => {

    let {api,renderResult,searchKey,getKey,queryKey} = useEndPoint(masterType);  // Fetching endpoint for platfrom specific
    let tenant = useSelector(state=>state.auth.config.tenant);
    const [value,setValue] = useState(undefined);

    useImperativeHandle(ref,()=>({
        getValue:()=>{
            if(masterType==='EMPLOYEE') return tenant==='STELMC' && value && value.email ? value.email : value?`${value[getKey]}|${value.code}|${value.email}`:undefined;
            if(masterType==='VENDOR') return value?`${value[getKey]}|${value.id}|${value.email}`:undefined;
            return value?value[getKey]:undefined;
        },
        value: value?value[getKey]:undefined,
        setValue:(value=undefined)=>{
            setValue(value);
        }
    }))

    let payload = undefined;
    if(masterType==='DEPARTMENT'&& filterData && filterData['officeId']) {
        payload = {
            officeId:filterData['officeId']
        }
    }
    
    
    return(
          <SearchInput 
             queryKey={queryKey}
             label={label} 
             placeholder={placeholder}
             api={api}
             onSelect={setValue}
             renderResult={renderResult}
             className="mb2"
             searchKey={searchKey}
             payload={payload}
            />
    )
})

export default Index;